import * as THREE from 'three';
import { MutableRefObject, useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { useEvent } from 'react-use';

export function useLerpedMouse(lerp = 0.1): MutableRefObject<THREE.Vector2> {
    const mouse = useRef(new THREE.Vector2());

    useEvent('pointermove', (e: MouseEvent) => {
        const { mapLinear } = THREE.MathUtils;

        const x = mapLinear(e.pageX, 0, window.innerWidth, -1, 1);
        const y = mapLinear(e.pageY, 0, window.innerHeight, -1, 1);
        mouse.current.set(x, y);
    });

    const lerped = useRef(mouse.current.clone());
    useFrame(() => {
        lerped.current.lerp(mouse.current, lerp);
    });
    return lerped;
}
